import React, { Component } from 'react';
import { recover } from '../../lib/api';
import { Redirect, Link } from "react-router-dom";


class Reset extends Component {

    constructor(props) {
        super(props);

        this.state = {
            form: {
                password: "",
                confirmation: ""
            },
            error: null
        };

        this.onFormChange = this.onFormChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormChange(event) {
        const name = event.target.name;
        const value = event.target.value;

        this.setState(prevState => {
            return {
                form: {
                    ...prevState.form,
                    [name]: value
                },
                error: null
            };
        });
    }

    onFormSubmit(event) {
        event.preventDefault();

        if (this.state.form.password !== this.state.form.confirmation) {
            this.setState({
                error: "As palavras-passe não coincidem."
            });
            return;
        }

        recover.reset({ token: this.props.match.params.token, password: this.state.form.password })
            .then(() => {
                this.props.onSignIn();
            })
            .catch(error => {
                this.setState({
                    error: "O link é inválido ou expirou."
                });
            });
    }

    render() {
        const errorClass = this.state.error ? "is-danger" : "";

        if (this.props.user) {
            return (
                <Redirect to={{ pathname: "/after-sign-in" }} />
            );
        }

        return (
            <section id="redefinir" className="section is-fullscreen is-flex is-justify-content-center is-align-items-center">
                <div className="box p-5 has-background-white-bis" style={{maxWidth: '400px'}}>
                    <h1 className="title has-text-primary has-text-centered mb-5">Nova palavra-passe</h1>

                    <form name="reset" method="POST" onSubmit={this.onFormSubmit}>
                        <div className="field">
                            <p className="control has-icons-left">
                                <input className={"input " + errorClass} name="password" type="password" required
                                       placeholder="Nova palavra-passe" value={this.state.form.password}
                                       onChange={this.onFormChange}/>
                                <span className="icon is-small is-left">
                                    <i className="fas fa-lock"></i>
                                </span>
                            </p>
                        </div>
                        <div className="field">
                            <p className="control has-icons-left">
                                <input className={"input " + errorClass} name="confirmation" type="password" required
                                       placeholder="Confirmar palavra-passe" value={this.state.form.confirmation}
                                       onChange={this.onFormChange}/>
                                <span className="icon is-small is-left">
                                    <i className="fas fa-lock"></i>
                                </span>
                            </p>
                            {this.state.error && (
                                <p className="help is-danger">{this.state.error}</p>
                            )}
                        </div>
                        <div className="field">
                            <p className="control">
                                <button type="submit" className="button is-primary is-fullwidth">Guardar</button>
                            </p>
                        </div>
                    </form>

                    <p className="has-text-centered mt-3">
                        <Link to="/recuperar">Pedir um novo link</Link>
                    </p>
                </div>
            </section>
        );
    }
}

export default Reset;
